<template>
  <div :class="[baseCss, vertical ? `${baseCss}-vertical` : null]" :style="table">
    <table-layout equal-cells :class="[`${baseCss}-full`]" :y-align="vertical ? null : 'bottom'">
      <row v-for="(tick, row) in vertical ? tickMarks : 1" :key="row">
        <cell v-for="(tick, cell) in vertical ? 1 : tickMarks" :key="cell">
          <table-layout v-if="tickFractions" equal-cells :class="[`${baseCss}-fractions`, vertical ? 'h-full' : null]">
            <row v-for="row in vertical ? 2 : 1" :key="row">
              <cell v-for="fraction in vertical ? 1 : 2" :key="fraction" />
            </row>
          </table-layout>
        </cell>
      </row>
    </table-layout>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'SliderTicks',
  mixins: [
    methods
  ],
  data () {
    return {
      offsetHeight: null,
      baseCss: this.componentBaseCss('slider-ticks', [])
    }
  },
  computed: {
    tickMarks () {
      return this.max / this.step
    },
    table () {
      return this.vertical ? {height: `${this.offsetHeight}px`} : {}
    }
  },
  mounted () {
    this.getOffsetHeight()
  },
  props: {
    step: {
      type: Number
    },
    vertical: {
      type: Boolean
    },
    max: {
      type: Number
    },
    uuid: {
      type: String
    },
    tickFractions: {
      type: Boolean
    }
  },
  methods: {
    getOffsetHeight () {
      this.offsetHeight = document.querySelector(`[data-slider="${this.uuid}"] input[type="range"]`).offsetHeight
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/slider/slider-ticks.vue